export enum AnalyticTab {
    CustomerJorney,
    Statistic,
    Monitoring,
    Reports
}